import { FC, useCallback, useContext, useState } from 'react';

import { scrollToTop } from '../../../../../../../shared/components';
import { GenericDataFormContext, StepOneFormContext } from '../../contexts';
import { QUOTATION_BUTTON } from '../../interfaces';

import { StepButtons } from '../../../../../../../shared/components/StepButtons';

interface QuotationStepButtonsProps {
  label?: string;
  onClick?: () => void;
  onPressBackButton?: () => void;
  htmlType?: 'submit' | 'button';
}

export const QuotationStepButtons: FC<QuotationStepButtonsProps> = ({
  label = 'Continuar',
  onClick = () => {},
  onPressBackButton = () => {},
  htmlType = 'submit',
}) => {
  const { clientSelected, additionalDataClientSelected } = useContext(StepOneFormContext);
  const { saveQuotation } = useContext(GenericDataFormContext);

  const [isSavingQuotation, setIsSavingQuotation] = useState<boolean>(false);

  const showSaveQuotation = label === QUOTATION_BUTTON.EMITIR;

  const onPressBack = () => {
    onPressBackButton();
    scrollToTop();
  };

  const onPressClick = () => {
    onClick();
    scrollToTop();
  };

  const onClickSaveQuotation = useCallback(async () => {
    setIsSavingQuotation(true);

    try {      
      await saveQuotation(clientSelected!, additionalDataClientSelected!);
    } catch (error) {
    } finally {
      setIsSavingQuotation(false);
    }
  }, [clientSelected, additionalDataClientSelected, setIsSavingQuotation, saveQuotation]);

  return (
    <StepButtons
      onPressBackButton={onPressBack}
      onPressConfirmButton={onPressClick}
      primaryButton={{label}}
      secondaryButton={
        showSaveQuotation
          ? {
              label: 'Guardar Cotización',
              onClick: onClickSaveQuotation,
              loading: isSavingQuotation,
              disabled: isSavingQuotation,
              type: 'secondary',
            }
          : undefined
      }
      htmlTypeConfirmButton={htmlType}
    />
  );
};
